import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ExcelImportUserResponse } from './../../DTO/ExcelImportUserResponse';
import { _userServicesService } from 'src/app/_services/_UserService/_userServices.service';
import { ImportFileService } from './../../_services/ImportFile/ImportFile.service';
import { Component, OnInit } from '@angular/core';
import { PreloaderService } from 'src/app/_services/Preloader.service';
import { ToasterService } from 'src/app/_services/Toaster.service';
import { DeviceService } from 'src/app/_services/_DeviceService/Device.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserTemplatesService } from 'src/app/_services/UserTemplates/UserTemplates.service';
import { HttpResponse } from '@angular/common/http';
import { Device } from 'src/app/_models/Device';
import { User } from 'src/app/_models/User';
import { UserTemplates } from 'src/app/_models/UserTemplates';

@Component({
  selector: 'app-Import_File',
  templateUrl: './Import_File.component.html',
  styleUrls: ['./Import_File.component.css']
})
export class Import_FileComponent implements OnInit {


  dataTable = false;
  selectedDeviceFrom: string;
  selectedDeviceTo: string;
  Device: Device[];
  public Users: User[];
  isChecked = false;
  UserIDList: Array<any> = [];
  UserTemplates: UserTemplates[];
  fileToUpload:File;
  ExcelUploadResponse:ExcelImportUserResponse;

  constructor(private SpinserService:NgxSpinnerService, private impServ:ImportFileService, private UTemplates: UserTemplatesService, private preloader: PreloaderService, private DeviceService: DeviceService, private UserService: _userServicesService, private noti: ToasterService) { }


  ngOnInit() {
    this.preloader.hide();
    this.LoadAllDevices();
  }
  selectChangeHandlerDeviceFrom(event: any) {
    this.selectedDeviceFrom = event.target.value;

  }

  LoadAllDevices() {
    this.SpinserService.show();
    try {
      this.DeviceService.GetActiveDeviceList().subscribe(
        Response => {
          this.SpinserService.hide();
          if (Response.status == 200) {
            this.Device = Response.body;
          }
          else {
            this.noti.error("Error", Response.body);
         }
        },
        err => {
          this.SpinserService.hide();
          this.noti.error("Error", err.error);
        }
      );
    } catch (error) {
      this.SpinserService.hide();
      this.noti.error("Error", "Code Crashed");
    }
  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
}



uploadFileToActivity() {
  let formData: FormData = new FormData();
  formData.append("data", this.fileToUpload);
  formData.append('deviceId', this.selectedDeviceFrom);

  this.dataTable = false;
    this.SpinserService.show();
    try {
      this.impServ.postFile(formData).subscribe(
         Response => {
            this.SpinserService.hide();

            if (Response.status == 200) {
               this.dataTable=!this.dataTable;
               this.ExcelUploadResponse=Response.body;


            }
            else {
               this.noti.error("Error", Response.body);
            }

         },
         err => {
            this.SpinserService.hide();
            if(err.status==400)
            {
              this.noti.error("Given Template is not a valid format","Error");
            }
            else if(err.status==500)
            {
              this.noti.error("Error",err.error);

            }

         }
      );
   } catch (error) {
      this.SpinserService.hide();

   }

}
}
